import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';
import PubSub from 'pubsub-js';

import BankAccountsPaginator from './BankAccountsPaginator';
import UsedLinksPaginator from './UsedLinksPaginator';
import CreditCardsPaginator from './CreditCardsPaginator';
import ItemsPaginator from './ItemsPaginator';
import TokensPaginator from './TokensPaginator';
import PurchasesPaginator from './PurchasesPaginator';
import SalesPaginator from './SalesPaginator';
import TransactionsPaginator from './TransactionsPaginator';

export default types
  .model('User', {
    isLoading: false,
    isToggling: false,
    isLoggingInAs: false,
    showTogglePrompt: false,
    showLoginPrompt: false,
    wasActive: false,
    error: types.maybeNull(types.string),

    email: types.string,
    login: types.maybe(types.string),
    is_active: types.maybe(types.boolean),
    phone_number: types.maybeNull(types.string),
    address: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    balance: types.maybe(types.number),
    created_at: types.maybe(types.string),
    registration_method: types.maybe(types.string),

    bank_accounts: types.optional(BankAccountsPaginator, {}),
    credit_cards: types.optional(CreditCardsPaginator, {}),
    used_links: types.optional(UsedLinksPaginator, {}),
    items: types.optional(ItemsPaginator, {}),
    tokens: types.optional(TokensPaginator, {}),
    purchases: types.optional(PurchasesPaginator, {}),
    sales: types.optional(SalesPaginator, {}),
    transactions: types.optional(TransactionsPaginator, {}),
  })
  .actions(self => ({
    afterCreate() {
      self.bank_accounts.email = self.email;
      self.bank_accounts.load();
      self.used_links.email = self.email;
      self.used_links.load();
      self.credit_cards.email = self.email;
      self.credit_cards.load();
      self.items.email = self.email;
      self.items.load();
      self.tokens.email = self.email;
      self.tokens.load();
      self.purchases.email = self.email;
      self.purchases.load();
      self.sales.email = self.email;
      self.sales.load();
      self.transactions.email = self.email;
      self.transactions.load();
    },

    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.error = null;
        self.isLoading = true;

        try {
          response = yield makeRequest('admin-user-data', null, { email: self.email });
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),

    promptStatusToggle() {
      self.isToggling = false;
      self.wasActive = self.is_active;
      self.showTogglePrompt = true;
    },

    closeTogglePrompt() {
      self.showTogglePrompt = false;
    },

    toggleStatus: flow(function* toggleStatus() {
      let response;

      if (!self.isToggling) {
        self.isToggling = true;

        try {
          response = yield makeRequest('admin-toggle-user-status', self);
          self.is_active = response.data;
        } catch (error) {
          PubSub.publish('popup-text', { type: 'error', message: errorResponse(error) });
        }

        self.showTogglePrompt = false;
      }

      return response;
    }),

    promptLogin() {
      self.isLoggingInAs = false;
      self.showLoginPrompt = true;
    },

    closeLoginPrompt() {
      self.showLoginPrompt = false;
    },

    loginAs: flow(function* loginAs() {
      let response;

      if (!self.isLoggingInAs) {
        self.isLoggingInAs = true;

        try {
          response = yield makeRequest('admin-login-as', null, { email: self.email });
          document.location.href = '/';
        } catch (error) {
          PubSub.publish('popup-text', { type: 'error', message: errorResponse(error) });
        }
      }

      return response;
    }),
  }));
